import { RouterModule, Routes } from '@angular/router';
// APP ROUTES
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { KnowComponent } from './components/know/know.component';
import { ComprarComponent } from './components/comprar/comprar.component';
import { ContactComponent } from './components/contact/contact.component';
import { CompararComponent } from './components/comparar/comparar.component';
import { ServicesComponent } from './components/services/services.component';
import { SolicitarComponent } from './components/solicitar/solicitar.component';
import { CompaniesComponent } from './components/companies/companies.component';
import { FrequentQuestionsComponent } from './components/frequent-questions/frequent-questions.component';
import { ConfirmarComponent } from './components/confirmar/confirmar.component';
import { PoliticsComponent } from './components/politics/politics.component';

// Intermediarios
import { PerfilComponent } from './components/intermediarios/perfil/perfil.component';
import { CotizacionComponent } from './components/intermediarios/cotizacion/cotizacion.component';
import { PlataformaComponent } from './components/intermediarios/plataforma/plataforma.component';
import { IntermediariosComponent } from './components/intermediarios/intermediarios.component';
import { FrequentQuestionsComponent as IntermediariosQuestionsComponent } from './components/intermediarios/frequent-questions/frequent-questions.component';
import { PasajeroComponent } from './components/intermediarios/pasajero/pasajero.component';
import { ClienteComponent } from './components/intermediarios/cliente/cliente.component';
import { ComisionComponent } from './components/intermediarios/comision/comision.component';
// Promociones
import { CompraComponent } from './components/promociones/compra/compra.component';
import { DetalleComponent as PromocionesDetalleComponent } from './components/promociones/detalle/detalle.component';
import { PromocionesComponent } from './components/promociones/promociones.component';
import { CotizadorInfoComponent } from './components/cotizador/cotizadorinfo.component';
import { UpGradeComponent } from './components/up-grade/up-grade.component';
import { RegistroComponent } from './components/intermediarios/registro/registro.component';
import { ValidacionComponent } from './components/intermediarios/validacion/validacion.component';
import { ConfirmarCorreoComponent } from './components/intermediarios/registro/confirmar-correo/confirmar-correo.component';

const APP_ROUTES: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'comprar', component: ComprarComponent },
  { path: 'comparar', component: CompararComponent },
  { path: 'contacto', component: ContactComponent },
  { path: 'compañias', component: CompaniesComponent },
  { path: 'servicios', component: ServicesComponent },
  { path: 'conocenos', component: KnowComponent },
  { path: 'solicitar', component: SolicitarComponent },
  { path: 'preguntas-frecuentes', component: FrequentQuestionsComponent },
  { path: 'politicas', component: PoliticsComponent },
  { path: 'confirmar', component: ConfirmarComponent },
  { path: 'upgrade', component: UpGradeComponent },
  // Promociones
  { path: 'promociones', component: PromocionesComponent },
  { path: 'promociones/comprar', component: CompraComponent },
  { path: 'promociones/:id', component: PromocionesDetalleComponent },
  // Intermediarios
  { path: 'intermediarios', component: IntermediariosComponent },
  { path: 'intermediarios/confirmarCorreo', component: ConfirmarCorreoComponent },
  { path: 'intermediarios/validacion/:id', component: ValidacionComponent },
  { path: 'intermediarios/registro', component: RegistroComponent },
  { path: 'intermediarios/perfil', component: PerfilComponent },
  { path: 'intermediarios/plataforma', component: PlataformaComponent },
  { path: 'intermediarios/comision', component: ComisionComponent },
  { path: 'intermediarios/pasajero', component: PasajeroComponent },
  { path: 'intermediarios/cliente', component: ClienteComponent },
  { path: 'intermediarios/cotizacion/:id', component: CotizacionComponent },
  { path: 'intermediarios/preguntas-frecuentes', component: IntermediariosQuestionsComponent },
  // Cotizador
  { path: 'cotizador', component: CotizadorInfoComponent },
  // Cotizador CRM
  { path: 'comparar/:id/tipo/:tipo', component: CompararComponent },
  // If none route match redirect to HOME
  { path: '**', pathMatch: 'full', redirectTo: 'home' }
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES);



// WEBPACK FOOTER //
// ./src/app/app.routes.ts